import React from 'react'
import { Component } from 'react'
import { connect } from 'react-redux'
import { toast } from 'react-toastify'
import _ from 'lodash'

import { convertSearchObjectToBase64 } from 'utils/objToBase64'
import { Get } from 'utils/axios-token'
import Lang from 'Lang/General'

const HOC = (WrappedComponent) => {
  class WithHOC extends Component {
    state = {
      loading: false,
      selectedtoDownload: [],
      searchParams: [
        {
          label: Lang['COMPANY'][this.props.data.languageReducer.userSettings.admin_panel_language],
          col: 6,
          value: 'filter_company_names',
          param: '',
          type: 'multi-select',
          options: []
        },
        {
          label: Lang['FAIR_SHORT'][this.props.data.languageReducer.userSettings.admin_panel_language],
          value: 'filter_fair_short_titles',
          col: 6,
          param: '',
          isSingle: true,
          type: 'multi-select',
          options: []
        },
        {
          label: '',
          value: 'media_type',
          col: 12,
          param: [
            'want_logo',
            'want_image_1',
            'want_image_2',
            'want_press_release_1',
            'want_press_release_2',
            'want_portrait',
          ],
          type: 'checkbox',
          options: [
            {
              id: 'want_logo',
              name: `${Lang['LOGO'][this.props.data.languageReducer.userSettings.admin_panel_language]}`
            },
            {
              id: 'want_image_1',
              name: `${Lang['IMAGE'][this.props.data.languageReducer.userSettings.admin_panel_language]} 1`
            },
            {
              id: 'want_image_2',
              name: `${Lang['IMAGE'][this.props.data.languageReducer.userSettings.admin_panel_language]} 2`
            },
            {
              id: 'want_press_release_1',
              name: `${Lang['PRESS_RELEASE'][this.props.data.languageReducer.userSettings.admin_panel_language]} 1`
            },
            {
              id: 'want_press_release_2',
              name: `${Lang['PRESS_RELEASE'][this.props.data.languageReducer.userSettings.admin_panel_language]} 2`
            },
            {
              id: 'want_portrait',
              name: `${Lang['PORTRAIT'][this.props.data.languageReducer.userSettings.admin_panel_language]}`
            },
          ]
        },
      ],
      mediaMeta: {},
      selectedMedia: null,
      query: {
        page: 1,
        is_paginated: true
      },
      companies: [],
      fairs: [],
      medias: [],
      query: {},
    }

    onChangeMediaHOC = (key, val) => this.setState({ [key]: val })

    load = param => this.setState({ loading: param })
    requestSuccess = success => toast.success(success)
    requestError = error => toast.error(error)

    getMedia = query => {
      this.setState({ query })

      Get(
        `/api/v1/fex/medias?query=${convertSearchObjectToBase64(query)}`,
        this.getMediaSuccess,
        this.getMediaError,
        this.load
      )
    }
    getMediaSuccess = payload => this.setState({
      medias: payload.data,
      mediaMeta: payload.meta
    })
    getMediaError = error => this.requestError(error)

    getCompanies = (query) => {
      this.setState({ query })

      Get(
        `/api/v1/fex/portal_users?query=${convertSearchObjectToBase64({
          page: 1,
          is_paginated: false,
          filter: {
            "client_id": this.props.data.selectCenterReducer.selectedCenter.center.client_id
          }
        })}`,
        this.getCompaniesSuccess,
        this.getCompaniesError,
        this.load
      )
    }
    getCompaniesSuccess = payload => this.setState({
      companies: _.map(payload.data, child => ({
        label: child.company_name,
        value: child.id,
        id: child.id
      })),
    })
    getCompaniesError = error => this.requestError(error.toString())

    getFairs = () => {
      Get(
        `/api/v1/fex/fairs?query=${convertSearchObjectToBase64({
          page: 1,
          is_paginated: false,
          filter: {
            "is_active": true,
            "client_id": this.props.data.selectCenterReducer.selectedCenter.center.client_id
          }
        })}`,
        this.getFairsSuccess,
        this.getFairsError,
        this.load
      )
    }
    getFairsSuccess = payload => this.setState({
      fairs: _.map(payload.data, child => ({
        label: child.short_title,
        value: child.id,
        id: child.id
      }))
    })
    getFairsError = error => this.requestError(error.toString())

    render = () => {
      return (
        <WrappedComponent
          {...this.props}
          {...this.state}
          onLoadMedia={this.state.loading}
          getMedia={this.getMedia}
          getFairs={this.getFairs}
          getCompanies={this.getCompanies}
          onChangeMediaHOC={this.onChangeMediaHOC}
        />
      )
    }
  }
  const mapStateToProps = state => ({ data: state })
  return connect(mapStateToProps)(WithHOC)
}

export default HOC
